import { render, staticRenderFns } from "./ColorCustomizer.vue?vue&type=template&id=f679830e"
import script from "./ColorCustomizer.vue?vue&type=script&lang=js"
export * from "./ColorCustomizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports